Vue.asyncComponent('ak-snackbar', {
    methods: {
        removeMessage(message) {
            this.$removeGlobalMessage(message);
        }
    }
}, 'layout/ak-snackbar.html');